export default "__VITE_ASSET__FyhF2JaM__"